import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, useMediaQuery } from '@chakra-ui/react';
import { SingleDatePicker } from '@whitbread-eos/atoms';
import { formatDataTestId, useCustomLocale } from '@whitbread-eos/utils';
import { add } from 'date-fns';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ArrivalDate(_ref) {
  var _formField$props, _formField$props2;
  var formField = _ref.formField,
    control = _ref.control;
  var testId = formField === null || formField === void 0 ? void 0 : formField.testid;
  var defaultDate = new Date();
  var todayLabel = ((_formField$props = formField.props) === null || _formField$props === void 0 ? void 0 : _formField$props.todayLabel) || 'Today';
  var tomorrowLabel = ((_formField$props2 = formField.props) === null || _formField$props2 === void 0 ? void 0 : _formField$props2.tomorrowLabel) || 'Tomorrow';
  var maxDate = add(new Date(), {
    days: 364
  });
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var _useMediaQuery = useMediaQuery('(min-width: 576px)'),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    isLargerThanSm = _useMediaQuery2[0];
  return _jsx(Box, {
    "data-testid": formatDataTestId(testId, 'Container'),
    children: _jsx(Controller, {
      name: formField === null || formField === void 0 ? void 0 : formField.name,
      control: control,
      render: _ref2 => {
        var field = _ref2.field;
        var onChange = field.onChange;
        return _jsx(SingleDatePicker, _objectSpread(_objectSpread({}, language === 'de' ? {
          locale: 'de'
        } : {
          locale: 'en'
        }), {}, {
          name: formField === null || formField === void 0 ? void 0 : formField.name,
          minDate: defaultDate,
          maxDate: maxDate,
          inputPlaceholder: formField === null || formField === void 0 ? void 0 : formField.label,
          inputLabel: formField === null || formField === void 0 ? void 0 : formField.label,
          defaultStartDate: defaultDate,
          isRightIcon: true,
          popperPlacement: isLargerThanSm ? 'bottom' : 'top',
          displayDateFormat: "EEE d MMMM yyyy",
          dateFormat: "dd MMM yyyy",
          labels: {
            todayLabel,
            tomorrowLabel
          },
          datepickerStyles: {
            inputGroupStyles: {},
            datepickerInputElementStyles: inputStyle,
            bookingDatepickerSize: {},
            iconStyles: inputIconStyles
          },
          onSelectDate: date => {
            onChange(date);
          }
        }));
      }
    })
  });
}
var inputStyle = {
  height: 'var(--chakra-space-4xl)',
  _placeholder: {
    opacity: 0.7,
    color: 'var(--chakra-darkGrey1)'
  }
};
var inputIconStyles = {
  top: 'var(--chakra-space-sm)'
};